import { gql } from "graphql-tag";

const getCuestionarios = gql`
  query Query {
    questionnaires {
      id
      code
      name
      shortName
      description
      allowMultipleAnswers
      semaphores {
        id
        value_1
        value_2
        color
      }
      categories {
        id
        name
        description
        weighting
        parent {
          id
        }
      }
      status
    }
  }
`;
const getCuestionariosInfo = gql`
  query Questionnaires($args: FilterParamsInput) {
    questionnaires(args: $args) {
      id
      status
      shortName
      name
      description
      allowMultipleAnswers
      semaphores {
        id
        color
        value_1
        value_2
      }
    }
  }
`;
const getAsignacionesInst = gql`
query AvailableSurveys {
  availableSurveys {
    id
    institution_id
    questionary {
      id
      name
      allowMultipleAnswers
    }
    start_date
    due_date
    status
  }
}
`;
const getHojaRespuesta = gql`
  query FindAnswerSheet($allocationId: Int!) {
    findAnswerSheet(allocationId: $allocationId) {
      id
      answers {
        answerOption {
          id
        }
        question {
          id
        }
        comment
      }
    }
  }
`;
const getEstatusHoja = gql`
  query FindAnswerSheet($allocationId: Int!) {
    findAnswerSheet(allocationId: $allocationId) {
      status
    }
  }
`;

const getCuestionarioPorId = gql`
  query Questionnaires($args: FilterParamsInput) {
    questionnaires(args: $args) {
      id
      categories {
        id
        parent {
          id
        }
        questions {
          id
          required
          order
          description
          answers_options {
            id
            score
            description
          }
          weighting
        }
        description
        name
        weighting
      }
      status
      shortName
      name
      semaphores {
        color
        value_1
        value_2
      }
    }
  }
`;


export { getCuestionarios, getCuestionariosInfo, getAsignacionesInst, getHojaRespuesta, getEstatusHoja, getCuestionarioPorId }